import React, { useMemo, useState } from "react";
import web_design_services from '../../Images/web_design_services.webp';
import local_listing_service from '../../Images/local_listing_service.webp';
import crm_automation_services from '../../Images/crm_automation_services.webp';
import google_reviews_removal from "../../Images/google_reviews_removal.webp"
import { Link } from "react-router-dom";
const Hero = () => {
  const SERVICES = useMemo(
    () => [
      {
        key: "webdesign",
        label: "Webdesign",
        bg: web_design_services,
        to: "/webdesign-agentur-bremen",
      },
      {
        key: "local-listing",
        label: "Local Listing",
        bg: local_listing_service,
        to: "/local-listing-optimierung",
      },
      {
        key: "crm",
        label: "CRM",
        bg: crm_automation_services,
        to: "/ki-automatisierung-prozesse",
      },
      {
        key: "reviews",
        label: "Bewertungen",
        bg: google_reviews_removal,
        to: "/",
      },
    ],
    []
  );

  const [activeKey, setActiveKey] = useState(SERVICES[0].key);

  return (
    <section className="w-full bg-white mt-8">
      <div className="mx-auto w-[90%] 2xl:w-[70%]  pt-10 md:pt-14">
        <div className="rounded-3xl border border-[#cac6c6] bg-white shadow-[0_24px_70px_-30px_rgba(0,0,0,0.18)] overflow-hidden">
          <div className="gap-0">
            {/* LEFT CONTENT (STATIC) */}
            <div className="lg:col-span-5 p-7 sm:p-10 lg:p-12">
              {/* Static pill (you can change text) */}
              <div className="text-xs font-semibold tracking-widest text-[#8ec700] uppercase">
                ÜBER UNS
              </div>

              {/* Static heading */}

              <h2 className="mt-4  h2-mb h2-md h2-lg h2-2xl">
                Wir helfen Unternehmen innovativ zu sein.
              </h2>

              {/* Static paragraph 1 */}


              {/* Static paragraph 2 */}
              <p className="mt-4 text-slate-600 leading-relaxed">
                Wir unterstützen Unternehmen dabei, ihre digitale Präsenz zu
                optimieren und innovative Lösungen zu finden, die ihre Marke
                stärken und ihre Kundenbindung verbessern. Unser Ansatz ist
                stets kundenorientiert und auf langfristigen Erfolg ausgerichtet.
              </p>

              {/* Static CTA */}
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link to='/kontak' className="inline-flex items-center justify-center rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-slate-800">
                  Kostenloses Erstgespräch
                </Link>
                <Link to="/unverbindliches-angebot" className="inline-flex items-center justify-center rounded-full border border-[#cac6c6] bg-white px-5 py-2.5 text-sm font-medium text-slate-900 hover:bg-slate-50">
                  Angebot anfordern
                </Link>
              </div>


            </div>

            {/* RIGHT TILES (DYNAMIC) */}
            <div className="lg:col-span-7 md:pt-0  lg:pt-0  p-6 sm:p-8 lg:p-10">
              <div className="h-full w-full">
                {/* ✅ MOBILE: SLIDER (swipe) */}
                <div className="md:hidden">
                  <div className="flex items-stretch gap-4 overflow-x-auto pb-2 snap-x snap-mandatory [-webkit-overflow-scrolling:touch]">
                    {SERVICES.map((s) => (
                      <button
                        key={s.key}
                        onClick={() => setActiveKey(s.key)}
                        className="relative snap-center shrink-0 w-[82%] max-w-[340px] h-[360px] overflow-hidden rounded-3xl border border-[#cac6c6]"
                        type="button"
                      >
                        {/* Background */}
                        <div
                          className="absolute inset-0 bg-cover bg-center"
                          style={{ backgroundImage: `url(${s.bg})` }}
                        />
                        {/* Overlay */}
                        <div className="absolute inset-0 bg-[#0b2b40]/80" />

                        {/* Content */}
                        <div className="relative z-10 flex h-full flex-col justify-between p-6">
                          <div className="flex items-center justify-between">
                            <span className="inline-flex items-center rounded-full bg-white/15 px-3 py-1 text-xs font-semibold tracking-wide text-white ring-1 ring-white/20">
                              {s.label}
                            </span>

                            <Link
                              to={s.to}
                              onClick={(e) => e.stopPropagation()}
                              aria-label={`Mehr zu ${s.label}`}
                              className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white ring-1 ring-white/20 hover:bg-white/20"
                            >
                              <ArrowIcon />
                            </Link>

                          </div>

                          <div>
                            <div className="text-[24px] font-semibold leading-tight text-white">
                              {s.label}
                            </div>

                            <p className="mt-3 text-sm text-white/85 leading-relaxed">
                              Kurze Beschreibung zu <span className="font-semibold">{s.label}</span>{" "}
                              (hier kannst du deinen echten Text einsetzen).
                            </p>

                            <Link
                              to={s.to}
                              onClick={(e) => e.stopPropagation()} // IMPORTANT: prevents triggering the card button click
                              className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-900 hover:bg-white/90"
                            >
                              Mehr zu {s.label}
                              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-slate-900 text-white">
                                <ArrowSmallIcon />
                              </span>
                            </Link>

                          </div>
                        </div>
                      </button>
                    ))}
                  </div>

                  {/* Optional: small hint dots */}
                  <div className="mt-3 flex justify-center gap-2">
                    {SERVICES.map((s) => (
                      <span
                        key={s.key}
                        className={[
                          "h-2 w-2 rounded-full transition",
                          activeKey === s.key ? "bg-emerald-600" : "bg-slate-300",
                        ].join(" ")}
                      />
                    ))}
                  </div>
                </div>

                {/* ✅ DESKTOP: your expandable tiles (same as before) */}
                <div className="hidden md:flex md:flex-row gap-4 md:h-[460px] lg:h-[520px]">
                  {SERVICES.map((s) => {
                    const isActive = s.key === activeKey;

                    return (
                      <button
                        key={s.key}
                        onClick={() => setActiveKey(s.key)}
                        className={[
                          "group relative h-full overflow-hidden rounded-3xl border transition-all duration-300 ease-out",
                          "focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/30",
                          isActive
                            ? "flex-[1.9] border-[#cac6c6] shadow-[0_22px_55px_-30px_rgba(0,0,0,0.25)]"
                            : "flex-[0.62] border-[#cac6c6] hover:border-slate-300 hover:shadow-md",
                        ].join(" ")}
                        type="button"
                      >
                        {/* Background */}
                        <div
                          className="absolute inset-0 bg-cover bg-center"
                          style={{ backgroundImage: `url(${s.bg})` }}
                        />

                        {/* Overlay */}
                        <div
                          className={[
                            "absolute inset-0 transition-opacity duration-300",
                            isActive
                              ? "bg-[#0b2b40]/90"
                              : "bg-[#24404dd1]/40 group-hover:bg-[#24404dd1]/50",
                          ].join(" ")}
                        />

                        {/* Content (your same logic) */}
                        {isActive ? (
                          <div className="relative z-10 flex h-full flex-col justify-between items-center p-6 sm:p-7">
                            {/* ...keep your active content... */}
                            <div className="flex items-center w-full justify-between">
                              <span className="inline-flex items-center rounded-full bg-white/15 px-3 py-1 text-xs font-semibold tracking-wide text-white ring-1 ring-white/20">
                                {s.label}
                              </span>

                              <Link
                                to={s.to}
                                onClick={(e) => e.stopPropagation()}
                                aria-label={`Mehr zu ${s.label}`}
                                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white ring-1 ring-white/20 hover:bg-white/20"
                              >
                                <ArrowIcon />
                              </Link>

                            </div>

                            <div className="max-w-[360px]">
                              <div className="text-[22px] sm:text-[28px] font-semibold leading-tight text-white">
                                {s.label}
                              </div>
                              <p className="mt-3 text-sm text-white/85 leading-relaxed">
                                Klicken, um mehr über <span className="font-semibold">{s.label}</span>{" "}
                                zu erfahren.
                              </p>

                              <Link
                                to={s.to}
                                onClick={(e) => e.stopPropagation()}
                                className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-900 hover:bg-white/90"
                              >
                                Mehr zu {s.label}
                                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-slate-900 text-white">
                                  <ArrowSmallIcon />
                                </span>
                              </Link>

                            </div>
                          </div>
                        ) : (
                          <div className="relative z-10 flex h-full w-full items-center justify-center">
                            <div className="absolute inset-0 flex items-center justify-center">
                              <span className="select-none text-white/90 text-lg font-semibold tracking-wide rotate-90">
                                {s.label}
                              </span>
                            </div>

                            <div className="absolute bottom-4 left-1/2 -translate-x-1/2">
                              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white ring-1 ring-white/20 group-hover:bg-white/20">
                                <ChevronIcon />
                              </div>
                            </div>
                          </div>
                        )}
                      </button>
                    );
                  })}
                </div>




              </div>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
};

export default Hero;

/* ---------------- Icons ---------------- */

function ArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M7 17L17 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9 7h8v8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ArrowSmallIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M8 16l8-8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10 8h6v6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 10l3 3 3-3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
